module.exports = __webpack_public_path__ + "static/media/copeland_skora.b06f2b76.gif";